import React, { useState } from 'react';
import { Button, Spinner } from 'reactstrap';
import documentsApi, { inferFilename } from 'service/documentsApi';

const triggerBrowserDownload = (url, filename) => {
  const a = document.createElement('a');
  a.href = url;
  if (filename) a.download = filename;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

const DocumentDownloadButton = ({ documentId, label = <i className="ni ni-cloud-download-95" />, className, disabled, details }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const downloadWithUrl = async (url, finalFilename) => {
    // No consumimos cuerpo innecesariamente; solo disparamos la descarga
    try {
      // Intento opcional de HEAD para detectar expiración sin consumir body
      const headResp = await fetch(url, { method: 'HEAD' });
      if (headResp.status === 401 || headResp.status === 403) {
        const err = new Error('Presigned URL expirado');
        err.status = headResp.status;
        throw err;
      }
    } catch (_) {
      // Si HEAD falla por CORS, seguimos con la descarga directa
    }
    triggerBrowserDownload(url, finalFilename);
  };

  const handleClick = async () => {
    if (!documentId) return;
    setLoading(true);
    setError(null);
    try {
      const first = await documentsApi.getPresignedDownloadUrl(documentId);
      if (first.url) {
        try {
          await downloadWithUrl(first.url, first.filename || inferFilename(details, documentId));
        } catch (e) {
          if (e?.status === 401 || e?.status === 403) {
            const second = await documentsApi.getPresignedDownloadUrl(documentId);
            if (second.url) {
              await downloadWithUrl(second.url, second.filename || inferFilename(details, documentId));
            } else {
              throw new Error('No se pudo obtener una nueva URL presignada.');
            }
          } else {
            throw e;
          }
        }
      } else {
        throw new Error('No se pudo obtener una URL para la descarga.');
      }
    } catch (err) {
      setError(err?.message || 'Error al descargar.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button color="primary" className={className} disabled={disabled || loading || !documentId} onClick={handleClick} aria-label="Download document">
        {loading ? <Spinner size="sm" /> : label}
      </Button>
      {error && (
        <div className="text-danger mt-1" style={{ fontSize: 12 }}>{error}</div>
      )}
    </>
  );
};

export default DocumentDownloadButton;



